import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}} % alennus summasta {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Säästä {{percentageAmount}} % valituista tuotteista',
  [OfferKindEnum.AmountOffByProducts]: 'Säästä {{amount}} valituista tuotteista',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Säästä {{amount}} summasta {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 yhden hinnalla – vain tänään',
  [OfferKindEnum.BogoHalfPrice]: 'Osta yksi, saat toisen puoleen hintaan',
  [OfferKindEnum.FreeItemByProducts]: 'Tänään: varmista ilmainen tuotteesi!',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Tänään: varmista ilmainen tuotteesi tilauksen arvolla!',
};

export default OfferLabel;
